import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { Link } from "react-router-dom";
import { BioData } from "../../../api/StudentsAttendance";
import { formatDate, formatDateTime, formatDateTimeUtc, ToastMain ,SweetAlertShow} from "../../master/Master";
import AttendanceHeader from "./AttendanceHeader";

const BioMetricData = () => {
    const [devices, setDevices] = useState([]); // ✅ array default
    const [logs, setLogs] = useState([]); // attendance logs
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState('');
    const [page, setPage] = useState(1)

    const fetchBio = async () => {
        // console.log("Fetching BioData..."); // 👈 check if function runs
        setLoading(true)
        const addUrl = `&search=${search}&page=${page}`
        try {
            const response = await BioData(addUrl);
            console.log("API Response:", response); // 👈 raw response
            if (response?.status) {
                setDevices(response?.data?.data[1]);
                setLogs(response?.data?.logs || []);
                console.log('device', response?.data?.data[1]?.
                    device_location
                )
            } else {
               
                SweetAlertShow('info','Warning',response?.message)
            }
        } catch (err) {
            console.error("fetchBio error:", err); // 👈 print error
           
            SweetAlertShow('error','Error',err?.response?.data?.message ?? err?.message)
        } finally {
            setLoading(false)
        }
    };



    useEffect(() => {
        fetchBio();
    }, [search, page]);
return (
        <>

            {loading && (
                <div
                    className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
                    style={{ zIndex: 9999 }}
                >
                    <div className="sk-chase sk-primary display-1">
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                    </div>
                </div>
            )}

            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="content-wrapper">
                            <div className="container-fluid mt-2">
                               <div className="row custom-scroll-layout">
                              
                                    <div className="col-md-2 left-pane">
                                        <AttendanceHeader data={'Attendance Portal'}/>
                                    </div>
                                    <div className="col-md-10 right-pane">
                                         <div className="card mb-1">
                                    <div className="card-body">
                                        <div className="d-flex">
                                            <h3 className="text-primary">Attendance Logs</h3>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <div className="form-floating form-floating-outline">
                                                <input className="form-control" type="text" name="search" placeholder="Search" value={search} onChange={(e) => setSearch(e.target.value)} />
                                                <label>Search</label>

                                            </div>
                                            {/* {(permissions?.[0]?.role_id == "1" ||
                                                permissions?.find(
                                                    (permission) =>
                                                        permission?.route?.frontend_url ==
                                                        "/attendance/biometric/export"
                                                )) && (
                                                    <button
                                                        className="btn btn-success btn-sm"
                                                          onClick={handleDownload}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Export Excel"
                                                    >
                                                     <i className="bi bi-cloud-arrow-down ri-20px"></i>
                                                    </button>
                                                )} */}
                                        </div>
                                    </div>
                                </div>
                                <div className="card p-4 mb-4 shadow-sm ">
                                    <div className="table-responsive">
                                        <table className="table ">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th>Sr.No</th>
                                                    <th>Name</th>
                                                    <th>User Type</th>
                                                    <th>Reg/Staff No</th>
                                                    <th>Log Date</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-capitalize">
                                                {logs.data?.length > 0 ? (
                                                    logs.data?.map((log, i) => (
                                                        <tr key={log.DeviceLogId}>
                                                            <td>{i + 1}</td>
                                                            <td>{log.name}</td>
                                                            <td>{log.user_type}</td>
                                                            <td>
                                                                {log.user_type === "student" ? log.registration_no : log.staff_id}
                                                            </td>
                                                            <td>{formatDateTimeUtc(log?.LogDate)}</td>
                                                            <td>{log.C1 === "out" ? "Present" : "Absent"}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6" className="text-center">{loading}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>

                                        <nav aria-label="Page navigation" className="mt-10">
                                            <p>
                                                Showing {logs?.from} to {logs?.to} of{" "}
                                                {logs?.total} entries
                                            </p>
                                            <ul className="pagination pagination-sm">
                                                {logs?.links?.map((btn, i) => (
                                                    <li
                                                        className={`page-item  ${btn?.active && "active"
                                                            }  ${btn?.url ? "" : "disabled"} `}
                                                    >
                                                        <button
                                                            className="page-link waves-effect"
                                                            onClick={() => {
                                                                if (logs?.links?.length === i + 1) {
                                                                    btn?.url &&
                                                                        setPage(logs?.current_page + 1);
                                                                } else if (i === 0) {
                                                                    btn?.url &&
                                                                        setPage(logs?.current_page - 1);
                                                                } else {
                                                                    setPage(btn.label);
                                                                }
                                                            }}
                                                        >
                                                            {logs?.links?.length == i + 1 ? (
                                                                <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
                                                            ) : i == 0 ? (
                                                                <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
                                                            ) : (
                                                                btn?.label
                                                            )}
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </nav>
                                    </div>

                                </div>
                                    </div>
                                
                               </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BioMetricData;
